import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Trash2, Plus } from 'lucide-react';

const VideosEditor = ({ data, setData }) => {
  const items = data.items || [];
  const update = (newItems) => setData({ ...data, items: newItems });

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">الصق رابط فيديو يوتيوب وسيتم تضمينه تلقائياً</p>
      {items.map((item, i) => (
        <Card key={i} className="p-4">
          <div className="flex items-start gap-3">
            <div className="flex-1 space-y-2">
              <Input value={item.title || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], title: e.target.value }; update(n); }} placeholder="عنوان الفيديو" data-testid={`vid-title-${i}`} />
              <Input value={item.url || ''} onChange={e => { const n = [...items]; n[i] = { ...n[i], url: e.target.value }; update(n); }} placeholder="https://www.youtube.com/watch?v=..." dir="ltr" data-testid={`vid-url-${i}`} />
            </div>
            <button onClick={() => update(items.filter((_, j) => j !== i))} className="text-red-400 hover:text-red-600 mt-2"><Trash2 className="w-5 h-5" /></button>
          </div>
        </Card>
      ))}
      <Button variant="outline" onClick={() => update([...items, { title: '', url: '' }])} className="w-full" data-testid="add-video">
        <Plus className="w-4 h-4 ml-2" /> إضافة فيديو
      </Button>
    </div>
  );
};

export default VideosEditor;
